import type { TAllAvailablePractices } from "@/api/models/patient/patient";
import { createPathParam, getAllPathParam, getPathParam } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";
import type {
  TActivateTreatmentPlan,
  ETreatmentType,
} from "@/api/models/treatmentPlan/treatmentPlan";
import type { TTreatmentPlanWithAvailableJobs } from "./types";
import type {
  ETreatmentPlanJobState,
  ETreatmentPlanJobType,
  TTreatmentPlanJob,
} from "../../treatmentPlan/job";

export * from "./types";

export interface IPatientTreatmentPlanFilter {
  patientId?: string;
}

export interface IPatientJobsFilter extends IPatientTreatmentPlanFilter {
  signal_type?: ETreatmentPlanJobType;
  signal_type__in?: ETreatmentPlanJobType[];
  state?: ETreatmentPlanJobState;
  ordering?: "created_at" | "completed_at" | "-created_at" | "-completed_at";
}

export interface IAllowedPracticesFilter {
  treatment_type?: ETreatmentType;
}

const SLUG = "patient";

export default createService(SLUG, {
  listPatientTreatmentPlansWithAvailableJobs: getAllPathParam<
    TTreatmentPlanWithAvailableJobs,
    { patientId: string }
  >(`${SLUG}/{patientId}/jobs-available-all-plans/`),

  listOfAvailableTreatmentPlans: getAllPathParam<string, { patientId: string }>(
    `${SLUG}/{patientId}/list-of-available-tratments/`
  ),

  listOfAvailableTreatmentForStaff: getAllPathParam<string>(`${SLUG}/allowed-treatment-for-staff/`),

  listOfAvailablePracticesForTreatmentType: getPathParam<TAllAvailablePractices>(
    `${SLUG}/allowed-practice-for-treatment-type/`
  ),

  activateTreatmentPlan: createPathParam<TActivateTreatmentPlan, { patientId: string }>(
    `${SLUG}/{patientId}/activate-treatment-plan/`
  ),

  listOfTreatmentJobs: getPathParam<TTreatmentPlanJob[], { patientId: string }>(
    `${SLUG}/{patientId}/treatment-jobs/`
  ),
});
